import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[clearFieldIf]'
})
export class ClearFieldIfDirective implements OnInit {

    constructor(
        private elementRef: ElementRef,
        private ngControl: NgControl
        ) { }
    ngOnInit() {
               
    }

    clearValueNotInitialize(target){
        target.value = target.value == '0' ? '' : target.value;
    }

    setValueNotInitialize(target){
        // console.log(target);
        this.ngControl.control?.setValue(target.value == '' ? '0' : target.value)
        
    }

    @HostListener("focus", ["$event.target"])
    onFocus(target) {
        this.clearValueNotInitialize(target)
    }

    @HostListener("blur", ["$event.target"])
    onBlur(target) {
        this.setValueNotInitialize(target)
    }
}
